import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-twitter",
  templateUrl: "./med-icon-twitter.component.html",
})
export class MedIconTwitterComponent extends SvgMixinComponent {}
